import {
	createApp
} from "vue";
import App from "./App.vue";
import ElementPlus, {
	ElMessage,
	ElMessageBox,
	ElNotification
} from "element-plus"; // 引入element-plus
import VueCookies from "vue-cookies";
import utils from "./lib/routerPath";
import router from "./router";
import * as ElIconModules from "@element-plus/icons-vue";
import * as api from "../request/http";
import headerPage from "./components/header/index";
import footerPage from "./components/footer/index";
import "element-plus/theme-chalk/index.css"; // 引入element-plus的样式
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'


const app = createApp(App);
app.config.globalProperties.$utils = utils;
app.config.globalProperties.$api = api;
app.config.globalProperties.$cookies = VueCookies;
app.use(router);
app.provide("$message", ElMessage);
app.provide("$notify", ElNotification);
app.provide("$messageBox", ElMessageBox);
app.component("headerPage", headerPage);
app.component("footerPage", footerPage);
app.use(ElementPlus, {
	locale: zhCn
});

Object.keys(ElIconModules).forEach(function(key) {
	app.component(ElIconModules[key].name, ElIconModules[key]);
});
app.mount("#app");
app.config.globalProperties.$router = router;


router.beforeEach((to, from, next) => {
	document.oncontextmenu = new Function("event.returnValue=false")
	document.addEventListener("keydown", function(e) {
		// 禁用开发者工具
		if (e.key == "F12") {
			e.preventDefault();
		}
		if (e.key == "Control" && e.key == "Shift" && e.key == "C") {
			e.preventDefault();
		}
	});
	next()
})